import { render, staticRenderFns } from "./OrgObjectActionsMenu.vue?vue&type=template&id=4ded3954&scoped=true"
import script from "./OrgObjectActionsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgObjectActionsMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrgObjectActionsMenu.vue?vue&type=style&index=0&id=4ded3954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded3954",
  null
  
)

export default component.exports